import { ALLOWED_BUSINESSES, countryCode, defaultPoiTypesForBusiness } from "./constants";

export function resolveSelectedBusiness(raw) {
    const allowed = new Set([...ALLOWED_BUSINESSES, "all"]);
    const tokens = (raw || "")
        .toLowerCase()
        .split(",")
        .map((t) => t.trim())
        .filter(Boolean);

    if (tokens.length === 0) return "all";

    const valid = [];
    for (const t of tokens) {
        if (allowed.has(t)) valid.push(t);
        else console.warn(`TOTALMS: ${t} is not a valid business code`);
    }

    if (valid.length === 0) return "all";
    if (valid.includes("all")) return "all";
    return [...new Set(valid)].join(",");
}
export function resolveDefaultPoiTypes(businessOption, configTypes) {
    const selectedBusiness = resolveSelectedBusiness(businessOption);
    return defaultPoiTypesForBusiness(selectedBusiness).filter((type) => configTypes.indexOf(type) !== -1);
}
export function resolveSelectedCountry(raw) {
    if (!raw) return null;
    const val = raw.trim().toUpperCase();
    const allowed = new Set(Object.keys(countryCode));
    return allowed.has(val) ? val : null;
}
